import { render, staticRenderFns } from "./CareimageModal.vue?vue&type=template&id=53528874&scoped=true&lang=pug"
import script from "./CareimageModal.vue?vue&type=script&lang=ts"
export * from "./CareimageModal.vue?vue&type=script&lang=ts"
import style0 from "./CareimageModal.vue?vue&type=style&index=0&id=53528874&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53528874",
  null
  
)

export default component.exports